import {
  animate,
  animation,
  AnimationReferenceMetadata,
  keyframes,
  style,
} from '@angular/animations';

export const fadeOutAnimation: AnimationReferenceMetadata = animation(
  [
    animate(
      '{{ duration }} {{ delay }}',
      keyframes([
        style({
          opacity: 1,
        }),
        style({
          opacity: 0,
          height: 0,
        }),
      ]),
    ),
  ],
  {
    params: {
      duration: '140ms',
      delay: '100ms',
    },
  },
);
